module.exports = __webpack_public_path__ + "img/share_tip.338d5f7c.png";